import { getCookie } from "./utils/getCookie";
import { setCookie } from "./utils/setCookie";

/*!
 * Revealing Module Pattern Boilerplate
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 */
export var UserIdentModal = (function () {

	'use strict';

  const cookieName = "user_ident";
  const UserIdentModalClosedEvent = new Event('user_ident:closed');
  const UserIdentModalHasBeenSeenEvent = new Event('user_ident:seen');

	//
	// Variables
	//

	var publicAPIs = {};


	//
	// Private Methods
	//
  var modalHasBeenSeen = function () {
    const modalHasBeenSeen = Boolean(getCookie(cookieName));

    if (modalHasBeenSeen) {
      document.dispatchEvent(UserIdentModalHasBeenSeenEvent); 
    }

    return modalHasBeenSeen;
  }
  
  var allowBodyToScoll = function (shouldAllow = true) {
    if(shouldAllow) {
      document.querySelector('body').classList.remove('userIdentIsOpen');
    } else {
      document.querySelector('body').classList.add('userIdentIsOpen');
    }
  }
  
  var closeModal = function () {
    allowBodyToScoll();
    document.querySelector('.user-ident-modal').classList.remove('is-open');
    document.dispatchEvent(UserIdentModalClosedEvent);
  }
  
  var setModalHasBeenSeen = function (typeOfUser) {
    setCookie(cookieName, typeOfUser, 2147483647);
  }
  
  var shouldDisplayModal = function () {
    if (modalHasBeenSeen()) {
      closeModal();
      return false;
    } else {
      return true;
    }
  }
  
  var setTypeOfUser = function (type) {
    setModalHasBeenSeen(type);
    setTypeOfUserNotifications();
    fireCustomerTypeSelectEvent();
  }
  
  var addButtonEvents = function (buttonEventFunction) {
    document.querySelectorAll('.user-ident-modal button').forEach(element => {
      element.addEventListener('click', buttonEventFunction, false);
    });
  };
  
  var doButtonClickEvent = function (event) {
    const button = event.target;
    const typeOfUser = button.dataset.userIdent;
  
    setTypeOfUser(typeOfUser);
    closeModal();
  }
  
  var getTypeOfUser = function () {
    return getCookie(cookieName);
  }
  
  var setTypeOfUserNotifications = function () {
    document.querySelectorAll('.user-ident-type-of-user').forEach(element => {
      element.innerHTML = getTypeOfUser();
    });
  }
  
  var fireCustomerType = function () {
    window.dataLayer.push({
      'customerType': getTypeOfUser()
    });
  }
  
  var fireCustomerTypeSelectEvent = function () {
    window.dataLayer.push({
      'event': 'Customer Type Select',
      'customerType': getTypeOfUser()
    });
  }

	/**
	 * Public Methods
	 */
  publicAPIs.openModal = function () {
    allowBodyToScoll(false);
    document.querySelector('.user-ident-modal').classList.add('is-open');
    addButtonEvents(doButtonClickEvent);
  }

  publicAPIs.modalHasBeenSeen = modalHasBeenSeen;

	publicAPIs.init = function (options) {
		const modalIsDisplaying = shouldDisplayModal();

    if (modalIsDisplaying) {
      addButtonEvents(doButtonClickEvent);
    }

    setTypeOfUserNotifications();
    fireCustomerType();
	};


	//
	// Return the Public APIs
	//

	return publicAPIs;

})();